/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

*/

import React from 'react';

// reactstrap components
import {
  Card,
  Container,
  Row,
  Col,
  Progress, Button, CardBody, Modal
} from "reactstrap";

import { RiEditFill, RiBookFill } from "react-icons/ri";
import withNavigationHook from "../../hooks/withNavigationHook";
import FeaturesMatrix from "../sales/FeaturesMatrix";
import { debugLog } from "../../utils/debug";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class ChooseLectionary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formModalUpgrade: false,
      value: '',
      activeButtonActive: false
    };

    debugLog("Clearing previously curated songs");

    sessionStorage.removeItem("selected-themes");
    sessionStorage.removeItem("selected-passages");
  }

  // 🔥 Safe customer check
  isCustomer = () => {
    try {
      return JSON.parse(sessionStorage.getItem("customer") || "false");
    } catch (e) {
      return false;
    }
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  render() {
    const isCustomer = this.isCustomer();

    return (
        <>
          <SeoHelper
            uri="/lectionary/choose-lectionary"
            title = "Choose a Lectionary | The Worship Bible"
            description="Find worship songs that align with your chosen denomination's lectionary."
          />

          <div className="position-relative">
            <section className="section section-lg section-shaped pb-10">
              <div className="shape shape-style-1 shape-default">
                <span/><span/><span/><span/><span/><span/><span/><span/><span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>choose a denomination</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              <div className="separator separator-bottom separator-skew">
                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
                     viewBox="0 0 2560 100">
                  <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
                </svg>
              </div>
            </section>
          </div>
          <section className="section section-lg mt-300"></section>
          <section className="section section-lg pt-lg-9">
            <Container className="mt--300 mb-5">
              <div className="px-4">

                {/* Pre-existing curated song-flow */}
                {(
                        (sessionStorage.getItem("curated-songs") &&
                            sessionStorage.getItem("curated-songs") !== 'null' &&
                            JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 &&
                            !sessionStorage.getItem("playlist"))
                        ||
                        (sessionStorage.getItem("playlist") &&
                            sessionStorage.getItem("workingOnDraft") === "true")
                    ) &&
                    <Row className="justify-content-center mb-4">
                      <Col lg="12">
                        <Card className="shadow border-0">
                          <CardBody className="py-5">
                            <div className="text-center">
                              <Button className="btn-icon mb-3 mb-sm-0 mx-auto"
                                      color="primary"
                                      href="/scripture/curated-songs">
                                <span className="btn-inner--icon mr-1"><RiEditFill size={16}/></span>
                                <span className="btn-inner--text">Go to song-flow</span>
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                }

                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row className="row-grid">

                      {/* --------------------- METHODIST --------------------- */}
                      <Col lg="6">
                        <Card className="shadow border-0">
                          <CardBody className="py-5">
                            <h2 className="text-primary text-uppercase d-flex align-items-center"
                                style={{fontSize: '1rem'}}>
                              <div className="icon icon-shape icon-shape-primary rounded-circle"><RiBookFill/></div>
                              <span className="ml-3">Methodist</span>
                            </h2>

                            <Row className="mt-4 btn-wrapper">
                              {!isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => this.toggleModal("formModalUpgrade")}>
                                    <span className="btn-inner--text">Methodist<br/>Lectionary</span>
                                  </Button>
                              }
                              {isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => {
                                            sessionStorage.setItem("selected-lectionary", "Methodist Lectionary");
                                            this.props.navigation('/lectionary/choose-date');
                                          }}>
                                    <span className="btn-inner--text">Methodist<br/>Lectionary</span>
                                  </Button>
                              }
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      {/* --------------------- RCL --------------------- */}
                      <Col lg="6">
                        <Card className="shadow border-0">
                          <CardBody className="py-5">
                            <h2 className="text-primary text-uppercase d-flex align-items-center"
                                style={{fontSize: '1rem'}}>
                              <div className="icon icon-shape icon-shape-primary rounded-circle"><RiBookFill/></div>
                              <span className="ml-3">Revised Common Lectionary (RCL)</span>
                            </h2>

                            <Row className="mt-4 btn-wrapper">
                              {!isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => this.toggleModal("formModalUpgrade")}>
                                    <span className="btn-inner--text">Revised Common<br/>Lectionary (RCL)</span>
                                  </Button>
                              }
                              {isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => {
                                            sessionStorage.setItem("selected-lectionary", "Revised Common Lectionary (RCL)");
                                            this.props.navigation('/lectionary/choose-date');
                                          }}>
                                    <span className="btn-inner--text">Revised Common<br/>Lectionary (RCL)</span>
                                  </Button>
                              }
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      {/* --------------------- CHURCH OF ENGLAND --------------------- */}
                      <Col lg="6">
                        <Card className="card shadow border-0 mt-3">
                          <CardBody className="py-5">
                            <h2 className="text-primary text-uppercase d-flex align-items-center"
                                style={{fontSize: '1rem'}}>
                              <div className="icon icon-shape icon-shape-primary rounded-circle"><RiBookFill/></div>
                              <span className="ml-3">Church of England</span>
                            </h2>

                            <Row className="mt-4 btn-wrapper">
                              {!isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => this.toggleModal("formModalUpgrade")}>
                                    <span className="btn-inner--text">Church of England<br/>Lectionary</span>
                                  </Button>
                              }
                              {isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => {
                                            sessionStorage.setItem(
                                                "selected-lectionary",
                                                "Church of England (Common Worship)"
                                            );
                                            this.props.navigation('/lectionary/choose-date');
                                          }}>
                                    <span className="btn-inner--text">Church of England<br/>Lectionary</span>
                                  </Button>
                              }
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      {/* --------------------- ROMAN CATHOLIC --------------------- */}
                      <Col lg="6">
                        <Card className="card shadow border-0 mt-3">
                          <CardBody className="py-5">
                            <h2 className="text-primary text-uppercase d-flex align-items-center"
                                style={{fontSize: '1rem'}}>
                              <div className="icon icon-shape icon-shape-primary rounded-circle"><RiBookFill/></div>
                              <span className="ml-3">Roman Catholic</span>
                            </h2>

                            <Row className="mt-4 btn-wrapper">
                              {!isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => this.toggleModal("formModalUpgrade")}>
                                    <span className="btn-inner--text">Roman Catholic<br/>Lectionary</span>
                                  </Button>
                              }
                              {isCustomer &&
                                  <Button color="primary" className="mx-auto"
                                          onClick={() => {
                                            sessionStorage.setItem("selected-lectionary", "Roman Catholic");
                                            this.props.navigation('/lectionary/choose-date');
                                          }}>
                                    <span className="btn-inner--text">Roman Catholic<br/>Lectionary</span>
                                  </Button>
                              }
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                    </Row>
                  </Col>
                </Row>

              </div>
            </Container>
          </section>

          {!isCustomer &&
              <>
                <FeaturesMatrix/>
              </>
          }

          {/* ------------------- UPGRADE MODAL ------------------- */}
          <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={this.state.formModalUpgrade}
              toggle={() => this.toggleModal("formModalUpgrade")}
          >
            <div className="modal-header">
              <h2 style={{fontSize: '1rem'}} className="modal-title">Lectionary ...</h2>
              <button aria-label="Close" className="close"
                      onClick={() => this.toggleModal("formModalUpgrade")}>
                <span aria-hidden={true}>×</span>
              </button>
            </div>

            <div className="modal-body p-0">
              <Card className="bg-secondary shadow border-0">
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="text-center text-muted mb-4">
                    Using a Lectionary to build a song-flow is one of the many benefits you receive from being a signed
                    up member.
                  </div>

                  <div className="text-center">
                    <Button className="my-4" color="primary"
                            onClick={() => this.props.navigation("/benefits")}>
                      <i className="fa fa-share-alt" aria-hidden="true"></i>
                      <span className="btn-inner--text">View benefits</span>
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Modal>

        </>
    );
  }
}

export default withNavigationHook(ChooseLectionary);
